//子级router-view承载
import Center from '@/components/common/center'

//==========财务账单===========//
//计费说明
import Charging from '@/pages/finance/charging'
//账单统计
import Report from '@/pages/finance/bill/report'
//账单
import Bill from '@/pages/finance/bill/list'
//账单明细
import BillDetail from '@/pages/finance/bill/detail'
//账单明细-费用查看
import BillCost from '@/pages/finance/bill/cost.detail'
//待付账单
import Paying from '@/pages/finance/bill/paying'
//充值
import Recharge from '@/pages/finance/recharge'

export default [{
  path: '/Finance',
  component: Center,
  redirect: '/Finance/Charging',
  meta: {
    title: '财务账单'
  },
  children: [{
    path: '/Finance/Charging',
    component: Charging,
    meta: {
      title: '计费说明'
    },
  }, {
    path: '/Finance/Bill',
    component: Center,
    meta: {
      title: '账单'
    },
    children: [{
      path: '/Finance/Report',
      component: Report,
      meta: {
        title: '账单总览'
      },
    }, {
      path: '/Finance/Bill',
      component: Bill,
      meta: {
        title: '账单'
      },
    }, {
      path: '/Finance/BillDetails',
      component: BillDetail,
      meta: {
        title: '账单明细'
      },
    }, {
      path: '/Finance/BillCost',
      component: BillCost,
      meta: {
        title: '账单费用'
      },
    }, {
      path: '/Finance/Paying',
      component: Paying,
      meta: {
        title: '付款'
      },
    }]
  }, {
    path: '/Finance/Recharge',
    component: Recharge,
    meta: {
      title: '充值'
    },
  }]
}]



// WEBPACK FOOTER //
// ./src/router/module/bill.js